<div id="n-list" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">N-LIST (National Library and Information Services)</h2>

    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College Library is a member of the **National Library and Information Services Infrastructure for Scholarly Content (N-LIST)**. This initiative provides students and faculty with access to a massive repository of digital learning resources.
    </p>

    <div class="row mt-4">
      <div class="col-md-8">
        <h4 class="section-subtitle">Resources Available</h4>
        <ul class="inner-lead">
          <li>Access to over <strong>6,000+ e-journals</strong> across various disciplines.</li>
          <li>Access to more than <strong>1,99,500+ e-books</strong> for research and academic study.</li>
          <li>Remote access to high-quality scholarly content from international publishers.</li>
        </ul>

        <div class="alert alert-info mt-4">
          <h5 class="fw-bold"><i class="fa fa-info-circle me-2"></i>How to Access</h5>
          <p class="mb-0">
            Students and staff members can obtain their unique <strong>User ID and Password</strong> from the College Librarian to access the portal.
          </p>
        </div>

        <div class="mt-4">
          <a href="https://nlist.inflibnet.ac.in/collegeadmin/" target="_blank" class="pdf-download-btn">
            <i class="fa fa-external-link me-2"></i>Login to N-LIST Portal
          </a>
        </div>
      </div>

      <div class="col-md-4">
        <div class="card shadow-sm border-0 bg-light p-3">
          <h5 class="fw-bold mb-3">Quick Stats</h5>
          <div class="d-flex justify-content-between mb-2">
            <span>E-Journals:</span>
            <span class="fw-bold">6,000+</span>
          </div>
          <div class="d-flex justify-content-between mb-2">
            <span>E-Books:</span>
            <span class="fw-bold">1,99,500+</span>
          </div>
          <div class="d-flex justify-content-between">
            <span>Access:</span>
            <span class="fw-bold">24 / 7</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
